export default "__VITE_ASSET__DIG2QEBU__"